//Importing Components
import Topbar from "../../components/topbar/Topbar.jsx"
import Sidebar from "../../components/sidebar/Sidebar.jsx"
import Feed from "../../components/feed/Feed.jsx"
import { AuthContext } from "../../context/AuthContext.js"
import Axios from 'axios'
import Rightbar from "../../components/rightbar/Rightbar.jsx"
import { Add, Check } from '@material-ui/icons'

import { useHistory } from 'react-router-dom'
import { useState, useEffect, useContext} from 'react'
import { useParams } from "react-router"

//Importing  
import './profile.css'

const Profile = () => {
    //Constants
    const PF = process.env.REACT_APP_PUBLIC_FOLDER
    const API = process.env.REACT_APP_API_URL

    //Setting the states
    const [user, setUser] = useState({
        followers: []
    })
    const [isFollowed, setIsFollowed] = useState(false)
    const [isFetching, setIsFetching] = useState(false)
    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")

    const {username} = useParams()
    const {user: currentUser, dispatch} = useContext(AuthContext)
    
    const history = useHistory()

    //Fetching the user
    useEffect(() => {
        const fetchUser = async () => {
            setIsFetching(true)
            const res = await Axios.get(API + `users/?username=${username}`)
            setIsFetching(false)
            setUser(res.data.user)
            setIsFollowed(res.data.user.followers.includes(currentUser._id))
        }
        fetchUser()
    }, [username, API, isFollowed, currentUser._id])

    //Handle the click on follow/unfollow button
    const handleClick = async () => {
        try {
            if(isFollowed){
                await Axios.patch(API + `users/${user._id}/unfollow`, {userId: currentUser._id})
                dispatch({
                    type: 'UPDATE_USER',
                    payload: {...currentUser, following: currentUser.following.filter((following) => following !== user._id)}
                })
            }
            else{
                await Axios.patch(API + `users/${user._id}/follow`, {userId: currentUser._id})
                dispatch({
                    type: 'UPDATE_USER',
                    payload: {...currentUser, following: [...currentUser.following, user._id]}
                })
            }
        } catch (error) {
          console.log(error)  
        }
        setIsFollowed(!isFollowed)
    }

    //Handle the click on the hi button
    const handleHi = async () => {

        try {
            const {data: {conversation}} = await Axios.post(API + 'conversations/create', {senderId: currentUser._id, receiverId: user._id})
            const {data: {msg, message}} = await Axios.post(API + 'messages/create', {conversationId: conversation._id, sender: currentUser._id, text: 'Hello there👋'})
            
            setSuccess(msg)
            setError("")
            setTimeout(() => {
            setSuccess("")
            setError("")
            }, 3000)
        } catch (error) {
            if(error.response && (error.response.status >= 400 && error.response.status <= 500)){
                setError(error.response.data.msg)
                setSuccess("")
                setTimeout(() => {
                  setError("")
                  setSuccess("")
                }, 3000)
              }
        }

    }

    //The following button component
    const FollowingState = () => {
        if(!isFollowed){
            return <button className="followButton" style={{ marginRight: '3rem' }} onClick={handleClick}>Follow <Add /></button>;
        }
        else{
            return <button className="followedButton" style={{ marginRight: '3rem' }} onClick={handleClick}>Followed <Check /></button>
        }
    }

    //Say Hi button component 
    const SayHi = () => {
        return (
            <button className="followButton" onClick={handleHi}>Say Hi 👋</button>
        )
    }

    return (
        <>
            <Topbar/>
            <div className="profile">
                <Sidebar /> 
                <div className="profileRight">
                    <div className="profileRightTop">
                        <div className="profileCover">
                            <img src={PF + (user.coverPicture || "person/default_cover.jpg")} alt="" className="profileCoverImg" />
                            <img src={user.profilePicture || (PF + "person/default_avatar.jpg")} alt="" className="profileUserImg" />
                        </div>
                        <div className="profileInfo">
                            <h3 className="username">{user.username}</h3>
                            <span className="bio">{user.bio}</span>
                            {isFetching || (user.username !== currentUser.username) && 
                            <div style={{width: '100%' ,display: 'flex', justifyContent: 'center'}} >
                                <FollowingState />
                                <SayHi />
                            </div>
                            }
                            {
                                error &&
                                <div className="alert alert-danger text-center" role="alert">
                                    {error}
                                </div>
                            }
                            {
                                success &&
                                <div className="alert alert-success text-center" role="alert">
                                    {success}
                                </div>
                            }
                        </div>
                    </div>
                    <div className="profileRightBottom">
                        <Feed username = {username}/>
                        <Rightbar user={user} userFetching={isFetching} localisation="profile"/> 
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile
